module.exports = __webpack_public_path__ + "img/menu_1_banner.0d0a5f9e.png";